<tab-container>
    <ng-template tab-pane title="Material Constituents" [hasData]="_stateMap.hasMaterialDataFor('material-composition')" [active]="true">
        <material-composition [materialId]="material.materialId" [principalName]=material.principalSynonymText()></material-composition>
    </ng-template>
    <ng-template tab-pane title="Constituent of a Natural Material" [hasData]="_stateMap.hasMaterialDataFor('material-partof-compounds')">
        <material-partof-compounds [materialId]="material.materialId" [principalName]="material.principalSynonymText()"></material-partof-compounds>
    </ng-template>
</tab-container>
